import { lazy } from 'react'

export const Restrictions = lazy(() => import('./Restrictions'))
